// extracted by mini-css-extract-plugin
export default {"buttons":"PurchaseError_buttons__6ln4v","firstParagraph":"PurchaseError_firstParagraph__ZlTlE","wordBreak":"PurchaseError_wordBreak__K-wSl","noWrap":"PurchaseError_noWrap__qeKqs"};